import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IHSMDataTableRowFormMeta {  
  identifier: FormInputMeta,
  flag: FormInputMeta,
  address: FormInputMeta,
  port: FormInputMeta,
  status: FormInputMeta,

  // Schema
  schema: any,
}

const HSMDataTableRowFormMeta = {} as IHSMDataTableRowFormMeta;

HSMDataTableRowFormMeta.identifier = {
  name: 'identifier',
  type: 'text',
  label: 'ID',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
HSMDataTableRowFormMeta.flag = {
  name: "flag",
  label: "Flag",
  type: "select",
  options:  [
    {
      label: 'Flag A',
      value: 'a'
    },
    {
      label: 'Flag B',
      value: 'b',
    },
    {
      label: 'Flag C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};
HSMDataTableRowFormMeta.address = {
  name: 'address',
  type: 'text',
  label: 'Adresse',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
HSMDataTableRowFormMeta.port = {
  name: 'port',
  type: 'text',
  label: 'Port',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
HSMDataTableRowFormMeta.status = {
  name: 'status',
  type: 'text',
  label: 'Statut',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

HSMDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(HSMDataTableRowFormMeta));

export default HSMDataTableRowFormMeta;